import React, { createContext, useContext, useRef } from 'react';


//this context is used to save a users scroll position between rerenders. there is a div in pagecontent.js that allows vertical scrolling with overflow y.
//by using a ref and passing to a child component we can save the scroll position between rerenders. the primary use case was apply receivable payments. 
//in prod some customers have a lot of invoices which makes the table long with vertical scrolling, when a user checked a box the page would rerender and cause the table to "jump" around.

const PageContentScrollContext = createContext<React.RefObject<HTMLDivElement> | null>(null);

export const PageContentScrollProvider = ({ children }) => {
  const contentRef = useRef<HTMLDivElement>(null);
  return (
    <PageContentScrollContext.Provider value={contentRef}>
      {children}
    </PageContentScrollContext.Provider>
  );
};

export const usePageContentScrollRef = () => {
  const ref = useContext(PageContentScrollContext);
  if (!ref) throw new Error('useContentScrollRef must be used within ContentScrollProvider');
  return ref;
};